export interface MaterialTreeNode {
  id: number
  materialId: number
  parentId: number | null
  nodeType: 'FOLDER' | 'FILE'
  name: string
  relativePath: string
  fileUrl?: string | null
  fileType?: string | null
  sizeBytes?: number | null
  children: MaterialTreeNode[]
}

function authHeaders(): HeadersInit {
  const token = localStorage.getItem('accessToken')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

async function downloadBlob(url: string, filename: string) {
  const res = await fetch(url, { headers: authHeaders() })
  if (!res.ok) {
    const data = await res.json().catch(() => ({}))
    throw new Error(data.message || 'Tải thất bại')
  }
  const blob = await res.blob()
  const objectUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = objectUrl
  a.download = filename
  a.click()
  URL.revokeObjectURL(objectUrl)
}

/** Prefer student API (admin can access via enrollment bypass). Admin paths as fallback prefix option. */
export const SampleProjectApi = {
  treeUrl(courseId: number, materialId: number, admin = false) {
    const base = admin ? '/api/v1/admin' : '/api/v1/student'
    return `${base}/courses/${courseId}/materials/${materialId}/tree`
  },

  fileContentUrl(
    courseId: number,
    materialId: number,
    nodeId: number,
    opts?: { raw?: boolean; admin?: boolean }
  ) {
    const base = opts?.admin ? '/api/v1/admin' : '/api/v1/student'
    const q = opts?.raw ? '?raw=1' : ''
    return `${base}/courses/${courseId}/materials/${materialId}/files/${nodeId}/content${q}`
  },

  downloadUrl(courseId: number, materialId: number, admin = false) {
    const base = admin ? '/api/v1/admin' : '/api/v1/student'
    return `${base}/courses/${courseId}/materials/${materialId}/download`
  },

  folderDownloadUrl(
    courseId: number,
    materialId: number,
    nodeId: number,
    admin = false
  ) {
    const base = admin ? '/api/v1/admin' : '/api/v1/student'
    return `${base}/courses/${courseId}/materials/${materialId}/folders/${nodeId}/download`
  },

  async getTree(courseId: number, materialId: number, admin = false) {
    const res = await fetch(this.treeUrl(courseId, materialId, admin), {
      headers: authHeaders(),
    })
    const data = await res.json()
    if (!res.ok || !data.success) {
      throw new Error(data.message || 'Không tải được cây thư mục')
    }
    return data.data as { material: any; tree: MaterialTreeNode[] }
  },

  async getFileContent(
    courseId: number,
    materialId: number,
    nodeId: number,
    admin = false
  ) {
    const res = await fetch(this.fileContentUrl(courseId, materialId, nodeId, { admin }), {
      headers: authHeaders(),
    })
    const data = await res.json()
    if (!res.ok || !data.success) {
      throw new Error(data.message || 'Không đọc được file')
    }
    return data.data as { content: string; node: Partial<MaterialTreeNode> }
  },

  async downloadProject(
    courseId: number,
    materialId: number,
    filename: string,
    admin = false
  ) {
    await downloadBlob(this.downloadUrl(courseId, materialId, admin), filename.endsWith('.zip') ? filename : `${filename}.zip`)
  },

  async downloadFolder(
    courseId: number,
    materialId: number,
    nodeId: number,
    filename: string,
    admin = false
  ) {
    await downloadBlob(
      this.folderDownloadUrl(courseId, materialId, nodeId, admin),
      filename.endsWith('.zip') ? filename : `${filename}.zip`
    )
  },
}
